
export const translation = (isEn) => {
    if (isEn) return translateEN;
    else if (!isEn) return translateKH;
}

const translateKH = {
    questionnaire: "កម្រងសំនួរ",
    choose: "ជ្រើសរើស",
    province: "ខេត្ត",
    people: "ចំនួនសមាជិកក្នុងក្រុម",
    find: "ស្វែងរក និង ជ្រើសរើស",
    input: "បញ្ចូល",
    under12: "ក្រោម ១២ ឆ្នាំ",
    from12to25: "១២ - ២៥ឆ្នាំ",
    from25to59: "២៥ - ៥៩ឆ្នាំ",
    age: "សូមជួយបញ្ជាក់ក្រុមអាយុ",
    above60: "លើស ៦០ឆ្នាំ",
    duration: "រយៈពេលទស្សនា",
    purpose: "គោលបំណងនៃការទស្សនា",
    transportation: "មធ្យោបាយធ្វើដំណើរ",
    save: 'រួចរាល់',
    headCount: "នាក់",
    notEqual: "ចំនួនដែលបានបំពេញ មិនស្មើ​នឹងចំនួនសរុប​នៃសមាជិកក្នងក្រុម",
    lang: "ខ្មែរ",
    wait: "សូមរង់ចាំ ពេលនេះយើងកំពុងធ្វើការស្វែងរកទីតាំងរបស់លោកអ្នក",
    pleaseAllow: "សូមបើកការអនុញ្ញាតទីតាំងភូមិសាស្ត្រ",
    pleaseScanAgain: "សូមស្កេនម្ដងទៀត",
    openQrScan: "ស្កេនម្ដងទៀត",
    headerInfo: { on: 'អ្នកនៅក្រៅតំបន់', un: 'សូមអរគុណ!' },
    back: 'ទៅទំព័រដើម',
    downloadPng: 'រក្សាទុក QR របស់លោកអ្នក',
    headerTitle: { on: 'សូមស្វាគមន៍មកកាន់', un: 'រមណីយដ្ឋានអង្គរ' },
    person: 'នាក់',
    boxInfo: {
        province: 'ខេត្ត',
        member: 'សមាជិក',
        time: 'រយៈពេល',
        purpose: 'គោលបំណង',
        date: 'កាលបរិច្ឆេទ'
    },
    information: { on: 'បានបំពេញរួចរាល់', un: 'សូមអរគុណ!' },
    noData: "រកមិនឃើញទិន្នន័យ",
    pleaseScan: "សុំស្កេនដើម្បីបញ្ចូលទិន្នន័យ",
    inputData: "បញ្ចូលទិន្នន័យ",
    success: "ជោគជ័យ",
    clickDownload: "ចុចប៊ូតុងខាងក្រោម​ដើម្បីទាញយកកម្មវិធី Visit Angkor",
    
}


const translateEN = {
    questionnaire: "Questionnaires",
    choose: "Select",
    province: "Province",
    people: "Number of members",
    find: "Search and Select",
    input: "Input",
    under12: "Under 12 y/o",
    from12to25: "12 - 25 y/o",
    from25to59: "26 - 59 y/o",
    above60: "Over 60 y/o",
    age: "Please specify members' age range",
    duration: "Duration of visit",
    purpose: "Purpose of visit",
    transportation: "Transportation",
    save: 'Done',
    headCount: "People",
    person_1: "Person",
    notEqual: "Information field is not equal to number of member",
    lang: "ENG",
    wait: "Please be patient as we retrieve your location coordinates before proceeding",
    pleaseAllow: "Please allow geolocation permission",
    pleaseScanAgain: "Please scan again!",
    openQrScan: "Open QR scan again",
    headerInfo: { on: "You're out of Zone", un: 'Thank you!' },
    downloadPng: 'Save your QR Code',
    back: 'Back to Home Page',
    headerTitle: { on: 'Welcome to', un: 'Angkor' },
    person: 'People',
    boxInfo: {
        province: 'Province',
        member: 'Members',
        time: 'Duration',
        purpose: 'Purpose',
        date: 'Date'
    },
    information: { on: 'Completed', un: 'Thank you!' },
    noData: "No Data to display",
    pleaseScan: "Please scan to input data",
    inputData: "Input Data",
    success: "Success",
    clickDownload: "Click button below to download the Visit Angkor app",
}

export {
    translateEN, translateKH
};

